import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import i18n from './i18n'
import axios from 'axios'
import VueGtm from "vue-gtm";
import firebase from "firebase/app";
import "firebase/analytics";
import store from '@/store/store'
// fron
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';


library.add(fas, far);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const isProduction = process.env.NODE_ENV === 'production';

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL_API;
axios.defaults.withCredentials = true;
axios.defaults.paramsSerializer = (params) => {
  // Sample implementation of query string building
  let result = '';
  Object.keys(params).filter(key => params[key] || params[key] == false).forEach(key => {
    result += `${key}=${encodeURIComponent(params[key])}&`;
  });
  return result.substring(0, result.length - 1);
}

Vue.config.productionTip = false;


if (process.env.NODE_ENV == 'production') {
  

  const options = {
    apiKey: process.env.VUE_APP_FB_API_KEY,
    authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
    projectId: process.env.VUE_APP_FB_PROJECTID,
    storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FB_APPID,
    measurementId: process.env.VUE_APP_FB_MEASUREMENTID
  };

  if(process.env.VUE_APP_SYSTEM_LOCALE == 'ko'){
    options['databaseURL'] = "https://zikoo-ee822.firebaseio.com";

    // GA
    Vue.use(VueGtm, {
      id: 'GTM-5V459WH'
      , vueRouter: router
    });
  }

  firebase.initializeApp(options);

  Vue.prototype.$analytics = firebase.analytics(firebase.app());
}

export default new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
